// @flow
import React, { Component } from "react";
import _ from "lodash";
import styles from "./Imports.scss";
import { connect } from "react-redux";
import I18n from "../../i18n/I18n";
import Actions from "../../actions/Creators";
import Dropdown from "../../components/common/filterDropdown/Dropdown";
import PreviewImports from "../../components/imports/PreviewImports";
import PreviewStock from "../../components/imports/PreviewStock";
import {
    Layout,
    Loader,
    Button,
    Icon,
    ToggleButton
} from "../../components/common/";

type State = {
    importsType: Number,
    page: Number,
    scrollPage: Number,
    scrollLimit: Number,
    importsType: Number,
    currentPage: Number,
    itemPerPage: Number,
    change: boolean
};

class Imports extends Component<void, State> {
    state = {
        importsType: 1,
        currentPage: 1,
        itemPerPage: 20,
        page: 1,
        scrollPage: 1,
        scrollLimit: 20,
        selectedBatch: null,
        selectedStockBatch: null,
        statusFilter: "all",
        change: false
    };

    componentDidMount = () => {
        const { importsType } = this.state;
        if (importsType === 1) {
            this.getBatches();
        } else {
            this.getStockBatches();
        }
    };

    //Getting list of batches
    getBatches = () => {
        const query = "";
        this.props.dispatch(Actions.getAsnBatchesImport(query));
    };

    //Getting list of stock batches
    getStockBatches = () => {
        const query = "";
        this.props.dispatch(Actions.getAsnBatchesStock(query));
    };

    //Getting lines for table
    getLines = id => {
        const { scrollPage, statusFilter, page, isExport } = this.state;
        let query = id ? `?id_partner_document=${id}` : "";
        query = scrollPage
            ? `${query}&limits=${isExport ? 5000 : 20}&page=${
                  isExport ? 1 : scrollPage
              }`
            : query;
        query = isExport ? `${query}&is_export=1` : query;
        query =
            statusFilter && statusFilter !== "all"
                ? `${query}&status=${statusFilter}`
                : query;
        this.props.dispatch(Actions.getImportLines(query, isExport));
        this.setState({
            change: false,
            isExport: false
        });
    };

    //Getting lines for table
    getStockLines = id => {
        const { scrollPage, page, isExport } = this.state;
        let query = id ? `?id_partner_document=${id}` : "";
        query = scrollPage ? `${query}&limits=${20}&page=${scrollPage}` : query;
        //query = isExport ? `${query}&is_export=1` : query;
        this.props.dispatch(Actions.getStockLines(query));
        this.setState({
            change: false,
            isExport: false
        });
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (
            (this.state.scrollPage &&
                this.state.scrollPage > prevState.scrollPage &&
                this.state.selectedBatch) ||
            this.state.change
        ) {
            if(this.state.importsType === 1) {
                this.getLines(this.state.selectedBatch);
            } else {
                this.getStockLines(this.state.selectedStockBatch)
            }
        }

        //  if (
        //     (this.state.scrollPage &&
        //         this.state.scrollPage > prevState.scrollPage &&
        //         this.state.selectedStockBatch && this.state.importsType === 2) ||
        //     this.state.change
        // ) {
        //     this.getStockLines(this.state.selectedStockBatch);
        // }
    };

    toggleImports = importsType => {
        if (importsType === 1) {
            this.getBatches();
        } else {
            this.getStockBatches();
        }
        this.setState({
            importsType
        });
    };

    // Exporting Eligible offers
    exportPSku = () => {
        this.props.dispatch(Actions.exportPSku());
    };

    exportStock = () => {
        this.props.dispatch(Actions.exportStock());
    }

    // IMPORTING PSKU UNIQUE
    importPSkuUnique = file => {
        this.props.dispatch(Actions.importPSkuUnique(file));
    };

    // IMPORTING PSKU UNIQUE
    importStock = file => {
        this.props.dispatch(Actions.importStock(file));
    };

    // toggling Batches
    toggleBatch = batch => {
        const newState = {};
        newState.selectedBatch = batch;
        newState.scrollPage = 1;
        newState.change = true;
        //this.getLines(batch);
        this.setState(newState);
    };

    // toggling Stock Batches
    toggleStockBatch = batch => {
        const newState = {};
        newState.selectedStockBatch = batch;
        newState.scrollPage = 1;
        newState.change = true;
        //this.getLines(batch);
        this.setState(newState);
    };

    loadFunc = () => {
        if (
            this.props.imports &&
            this.props.imports.lines &&
            this.props.imports.lines.no_of_pages &&
            this.props.imports.lines.no_of_pages > this.state.scrollPage
        ) {
            this.setState({
                scrollPage: this.state.scrollPage + 1
            });
        }
    };

    loadStockFunc = () => {
        if (
            this.props.imports &&
            this.props.imports.stockLines &&
            this.props.imports.stockLines.no_of_pages &&
            this.props.imports.stockLines.no_of_pages > this.state.scrollPage
        ) {
            this.setState({
                scrollPage: this.state.scrollPage + 1
            });
        }
    };

    // Function for filteration
    onStatusChange = e => {
        const newState = {};
        newState.statusFilter = e;
        newState.scrollPage = 1;
        newState.change = true;
        this.setState(newState);
    };

    //Function for filteration
    exportSelected = () => {
        const newState = {};
        newState.isExport = true;
        newState.change = true;
        this.setState(newState);
    };

    render() {
        const {
            imports,
            browser,
            products,
            isLoading,
            isImporting
        } = this.props;
        const { importsType } = this.state;
        const batches = imports ? imports.batches : [];
        const stockBatches = imports ? imports.stockBatches : [];
        const initialLines = imports ? imports.lines : [];
        const initialStockLines = imports ? imports.stockLines : [];
        const linesLength =
            initialLines && initialLines.lines && initialLines.lines.length;

        const status = [
            {
                value: "all",
                key: "all",
                label: I18n.getText("dashboard.all")
            },
            {
                value: "not_processed",
                key: "not_processed",
                label: I18n.getText("product.not-processed")
            },
            {
                value: "not_unique",
                key: "not_unique",
                label: I18n.getText("product.not-unique")
            },
            {
                value: "invalid_format",
                key: "invalid_format",
                label: I18n.getText("product.invalid-format")
            },
            {
                value: "complete",
                key: "complete",
                label: I18n.getText("orders.completed")
            }
        ];

        return (
            <Layout currentIndex={10} title={"imports.title"}>
                <div className={styles.importsCtr}>
                    {/* TABS AND FILTER START */}
                    <div className={styles.topWrapper}>
                        {/* TOGGLE TABS STARTS */}
                        <div>
                            <ToggleButton
                                toggleBtn={this.toggleImports}
                                toggleItems={[
                                    I18n.getText("imports.partner-sku-unique"),
                                    I18n.getText("imports.partner-offer-stock")
                                ]}
                                tab
                                selected={this.state.importsType}
                            />
                        </div>
                        {/* TOGGLE TABS ENDS */}
                    </div>
                    <div className={styles.filterWrapper}>
                        <div className={styles.eachFilter}>
                            {importsType === 1 ? (
                                <Button
                                    className={styles.flexer}
                                    variant="transparent"
                                    onClick={this.exportPSku}
                                >
                                    <Icon
                                        name="download"
                                        className={styles.icon}
                                    />
                                    {I18n.getText(
                                        "imports.export-all-offers",
                                        {},
                                        "Export All Offers"
                                    )}
                                </Button>
                            ) : (
                                <Button
                                    className={styles.flexer}
                                    variant="transparent"
                                    onClick={this.exportStock}
                                >
                                    <Icon
                                        name="download"
                                        className={styles.icon}
                                    />
                                    {I18n.getText(
                                        "imports.export-all-offers-stock",
                                        {},
                                        "Export All Offer Stock"
                                    )}
                                </Button>
                            )}
                        </div>
                        {importsType === 1 && (
                            <div className={styles.eachFilter}>
                                <Dropdown
                                    onChange={this.onStatusChange}
                                    selected={this.state.statusFilter}
                                    options={status}
                                    label={I18n.getText(
                                        "imports.status",
                                        {},
                                        "Status"
                                    )}
                                />
                            </div>
                        )}
                        {importsType === 1 && (
                            <div className={styles.eachFilter}>
                                <Button
                                    variant="secondary"
                                    disabled={!linesLength}
                                    className={`${styles.printCtr}`}
                                    onClick={() => this.exportSelected()}
                                >
                                    <Icon
                                        name="download"
                                        className={styles.printIcon}
                                    />
                                    {I18n.getText(
                                        "product.export-filtered-offers"
                                    )}
                                </Button>
                            </div>
                        )}
                    </div>
                    <div className={styles.previewCtr}>
                        {isLoading ? (
                            <Loader />
                        ) : importsType === 1 ? (
                            <PreviewImports
                                batches={batches}
                                initialLines={
                                    initialLines && initialLines.lines
                                }
                                browser={browser}
                                noOfPages={
                                    initialLines ? initialLines.no_of_pages : ""
                                }
                                importPSkuUnique={this.importPSkuUnique}
                                exportPSku={this.exportPSku}
                                importedBatch={
                                    products &&
                                    products.documentBatchId &&
                                    !_.isEmpty(products.documentBatchId) &&
                                    products.documentBatchId.id_partner_document
                                }
                                toggleBatch={this.toggleBatch}
                                isInitialLoading={this.props.isLoading}
                                isImporting={this.props.isImporting}
                                currentBatch={this.state.selectedBatch}
                                scrollPage={this.state.scrollPage}
                                loadFunc={this.loadFunc}
                                importsType={importsType}
                            />
                        ) : (
                            <PreviewStock
                                batches={stockBatches}
                                initialLines={
                                    initialStockLines && initialStockLines.lines
                                }
                                browser={browser}
                                noOfPages={
                                    initialStockLines ? initialStockLines.no_of_pages : ""
                                }
                                importStock={this.importStock}
                                exportPSku={this.exportPSku}
                                importedBatch={
                                    products &&
                                    products.documentBatchId &&
                                    !_.isEmpty(products.documentBatchId) &&
                                    products.documentBatchId.id_partner_document
                                }
                                toggleBatch={this.toggleStockBatch}
                                isInitialLoading={this.props.isLoading}
                                isImporting={this.props.isImporting}
                                currentBatch={this.state.selectedStockBatch}
                                scrollPage={this.state.scrollPage}
                                loadFunc={this.loadStockFunc}
                                importsType={importsType}
                            />
                        )}
                    </div>
                </div>
            </Layout>
        );
    }
}
const mapStateToProps = state => {
    return {
        lang: state.locale.lang,
        user: state.session.user,
        seller: state.session.seller,
        browser: state.browser,
        imports: state.import,
        isLoading: state.import.isBatchesLoading,
        isImporting: state.import.isLoading,
        products: state.products,
        stock: state
    };
};

export default connect(mapStateToProps)(Imports);



// WEBPACK FOOTER //
// ./src/containers/imports/Imports.js